import React from 'react';
import { Adjust } from '@adjustcom/adjust-web-sdk';

const AdjustContext = React.createContext<Adjust | undefined>(undefined);
export const AdjustProvider = AdjustContext.Provider;
export default AdjustContext;
